
import Vue from "vue";
import Component from "vue-class-component";
import filters from "@/filters";
import { isValidUrl } from "@/functions/global.function";
import toast from "@/functions/toast.function";
import { StreamBarcodeReader } from "vue-barcode-reader";

@Component({
  components: {
    StreamBarcodeReader,
  },
  filters,
})
export default class ScanQr extends Vue {
  private isLoading = true;
  private isGranted = true;
  private interval: any = null;

  private mounted() {
    this.interval = setInterval(() => {
      this.permission();
    }, 1000);
  }

  private beforeDestroy() {
    clearInterval(this.interval);
  }

  private permission() {
    navigator.permissions
      .query({
        name: "camera",
      })
      .then((res) => {
        this.isGranted = res.state === "granted";
      });
  }

  private onLoaded() {
    this.isLoading = false;
    this.permission();
  }

  private onDecode(text) {
    if (isValidUrl(text)) {
      if (
        text.includes(
          `${window.location.hostname}/${
            window.location.pathname.split("/")[1]
          }`
        )
      )
        window.location.href = text;
      else toast.warning("Kode QR tidak sesuai.");
    } else toast.warning("Invalid url.");
  }
}
